(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/date-selector.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/date-selector.js');
"use strict";

const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const _svs$tickets_giftshop = svs.tickets_giftshop.gift.giftform.date_selector.components,
  DateTimePicker = _svs$tickets_giftshop.DateTimePicker,
  NameDayByLetter = _svs$tickets_giftshop.NameDayByLetter,
  Now = _svs$tickets_giftshop.Now,
  NameDayByDate = _svs$tickets_giftshop.NameDayByDate,
  ThemeDayByDate = _svs$tickets_giftshop.ThemeDayByDate;
const namesByDate = svs.tickets_giftshop.gift.giftform.date_selector.namesByDateData.namesByDate;
const themeDaysByDate = svs.tur.theme_days.getThemeDays();
const DATE_SELECTOR = svs.tickets_giftshop.constants.names.DATE_SELECTOR;
const tabs = svs.tickets_giftshop.constants.dateSelectorTabs;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.constants.dateSelectorKey,
  NAME_DAY_BY_LETTER = _svs$tickets_giftshop2.NAME_DAY_BY_LETTER,
  NAME_DAY_BY_DATE = _svs$tickets_giftshop2.NAME_DAY_BY_DATE,
  NOW = _svs$tickets_giftshop2.NOW,
  THEME_DAY_BY_DATE = _svs$tickets_giftshop2.THEME_DAY_BY_DATE,
  DATE_AND_TIME = _svs$tickets_giftshop2.DATE_AND_TIME;
const DateSelector = React.forwardRef((_ref, ref) => {
  let date = _ref.date,
    time = _ref.time,
    nameDayName = _ref.nameDayName,
    dateSelector = _ref.dateSelector,
    onInputChange = _ref.onInputChange,
    _ref$minDate = _ref.minDate,
    minDate = _ref$minDate === void 0 ? svs.utils.date.SimpleDate(new Date()) : _ref$minDate,
    _ref$maxDate = _ref.maxDate,
    maxDate = _ref$maxDate === void 0 ? svs.utils.date.SimpleDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))) : _ref$maxDate;
  const onClick = (e, tabName) => {
    e.preventDefault();
    onInputChange({
      target: {
        value: tabName,
        name: DATE_SELECTOR
      }
    });
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-body"
  }, React.createElement("h2", {
    className: "tg-form-date-header h2 u-text-center margin-top-4 margin-bottom-2",
    ref: ref
  }, "N\xE4r vill du skicka lotterna?"), React.createElement(ItemsMenu, {
    centered: true,
    className: "tg-items-menu-hide-box-shadow tg-items-menu-border"
  }, tabs.map((_ref2, i) => {
    let key = _ref2.key,
      label = _ref2.label;
    const active = key === dateSelector;
    return React.createElement(LinkItem, {
      className: "tg-top-bar-tab ".concat(active && 'tg-top-bar-tab-active'),
      Component: "a",
      "data-id": key,
      "data-tab": i,
      href: "",
      key: "".concat(key + i),
      label: label,
      onClick: e => {
        onClick(e, key);
      },
      selected: active
    });
  })), dateSelector === NOW ? React.createElement(Now, {
    date: date,
    onInputChange: onInputChange
  }) : null, dateSelector === NAME_DAY_BY_DATE ? React.createElement(NameDayByDate, {
    date: date,
    dateData: namesByDate,
    maxDate: maxDate,
    minDate: minDate,
    onInputChange: onInputChange,
    time: time
  }) : null, dateSelector === NAME_DAY_BY_LETTER ? React.createElement(NameDayByLetter, {
    date: date,
    maxDate: maxDate,
    minDate: minDate,
    nameDayName: nameDayName,
    onInputChange: onInputChange,
    time: time
  }) : null, dateSelector === THEME_DAY_BY_DATE ? React.createElement(ThemeDayByDate, {
    date: date,
    dateData: themeDaysByDate,
    maxDate: maxDate,
    minDate: minDate,
    onInputChange: onInputChange,
    time: time
  }) : null, React.createElement(DateTimePicker, {
    date: date,
    isHidden: dateSelector !== DATE_AND_TIME,
    maxDate: maxDate,
    minDate: minDate,
    onInputChange: onInputChange,
    time: time
  })));
});
svs.tickets_giftshop.gift.giftform.date_selector.DateSelector = DateSelector;

 })(window);